<!-- TODO: site ayarla alakalı bir sorun olup buraya gelince cache temizlenebilir. -->
<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router'
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import SiteAyarService from '@/services/site_ayar'

const router = useRouter()
const route = useRoute()
const { t } = useI18n()

// Status kodunu query'den veya 404 olarak al
const statusCode = computed(() => {
  const status = route.query.status as string
  return status ? parseInt(status, 10) : 404
})

// Hata mesajını i18n ile al
const errorInfo = computed(() => {
  const status = statusCode.value
  const errorKeys: Record<number, string> = {
    400: 'bad_request',
    401: 'unauthorized',
    403: 'forbidden',
    404: 'not_found',
    500: 'server_error',
    503: 'service_unavailable',
  }

  const key = errorKeys[status] || 'generic_error'
  return {
    title: status.toString(),
    message: t(`error_page.${key}`),
  }
})

// Ana sayfaya yönlendirme
const handleError = () => {
  router.push('/')
}

onMounted(async () => {
    await SiteAyarService.getSiteAyar(route.query.force === 'true')
})
</script>

<template>
  <div class="error-page">
    <h1>{{ errorInfo.title }}</h1>
    <p>{{ errorInfo.message }}</p>
    <p v-if="statusCode === 404" class="path-info">
      {{ $t('error_page.page_not_found_path') }} <code>{{ route.path }}</code>
    </p>
    <p v-if="route.query.message" class="error-message">
      {{ route.query.message }}
    </p>

    <button @click="handleError">{{ $t('error_page.go_home') }}</button>
  </div>
</template>

<style scoped>
.error-page {
  text-align: center;
  margin-top: 5rem;
}
h1 {
  font-size: 4rem;
  color: #e11d48;
}
p {
  margin-bottom: 2rem;
}
.path-info {
  font-size: 0.9rem;
  color: #6b7280;
}
.error-message {
  color: #dc2626;
  font-weight: 500;
  padding: 1rem;
  background: #fef2f2;
  border-radius: 8px;
  max-width: 600px;
  margin: 0 auto 2rem;
}
code {
  background: #f3f4f6;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-family: monospace;
}
button {
  background: #3b82f6;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.2s;
}
button:hover {
  background: #2563eb;
}
</style>
